import { Typography } from '@design-system/atoms/typography';
import styled from '@emotion/styled';

export const Layout = styled.main`
  display: flex;
  height: 100vh;
  padding: 24px;
`;

export const LeftSection = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 752px;
  padding: 0 56px;
`;

export const LeftHeader = styled.header`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const LeftContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const LeftFooter = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
`;

export const RightSection = styled.section`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.secondary.normal};
  border-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  overflow: hidden;
`;

export const CopyRights = styled(Typography)`
  font-size: 10px;
  color: ${({ theme }) => theme.colors.technical.gray[30]};
`;

export const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 80%;
`;

export const ImageContainer = styled.div`
  margin-bottom: 32px;
  width: 100%;
`;

export const Header = styled(Typography)`
  color: ${({ theme }) => theme.colors.primary.dark};
  font-weight: 900;
`;

export const Body = styled(Typography)`
  margin-top: 16px;
  color: ${({ theme }) => theme.colors.technical.gray[60]};
`;

export const LanguagePicker = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LanguageButton = styled.button<{ $isSelected: boolean }>`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0 4px;
  color: ${({ theme, $isSelected }) => ($isSelected ? theme.colors.primary.normal : theme.colors.technical.gray[30])};

  &:hover,
  &:active {
    color: ${({ theme, $isSelected }) => ($isSelected ? theme.colors.primary.normal : theme.colors.secondary.dark)};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary.medium};
    outline-offset: -1px;
    border-radius: 8px;
  }
`;

export const LanguageText = styled(Typography)`
  font-weight: 600;
`;

export const Information = styled.div`
  color: ${({ theme }) => theme.colors.technical.gray[60]};
  display: flex;
  gap: 8px;
  padding: 16px;
  border-radius: 16px;
  margin-bottom: 10px;
  background-color: ${({ theme }) => theme.colors.background.medium};

  p {
    flex-grow: 1;
  }
`;
